import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from './constants';

const settingsService = createApi({
    reducerPath: 'settingsService',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('admin')
                ? JSON.parse(localStorage.getItem('admin')).token
                : null;
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        fetchSettings: builder.query({
            query: () => 'settings',
        }),
        updateSettings: builder.mutation({
            query: (settings) => ({
                url: 'settings',
                method: 'POST',
                body: settings,
            }),
        }),
    }),
});

export const { useFetchSettingsQuery, useUpdateSettingsMutation } = settingsService;
export default settingsService;
